import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UtilService } from './util.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import {
    BehaviorSubject,
    Subject,
    debounceTime,
    distinctUntilChanged,
} from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { ImportCsvComponent } from 'app/shared/import-csv/import-csv.component';
import { FormGroup } from '@angular/forms';
import { OnboardingService } from './onboarding.service';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class MappingService {
    mappingField: any;
    type: any;
    activeListId: any = '';
    progressbarLoad: any;
    attachFiles: any = [];
    errorMessageData: any;
    mappingData: any;
    isUploadProspect: boolean = false;
    fileUpload: any;
    isLoadMapping = new BehaviorSubject<Boolean>(false);
    isLoadMappingField = new BehaviorSubject<Boolean>(false);
    isLoadAllCustomers = new BehaviorSubject<Boolean>(false);
    isLoadingProspect = new BehaviorSubject<Boolean>(false);
    isLoadProgress = new BehaviorSubject<Boolean>(false);
    isLodingMapping: boolean = false;
    currentUrl: any;
    isProgressLoad: Subject<boolean> = new Subject<boolean>();
    customFields: any;
    isCustomFieldLoad = new BehaviorSubject<Boolean>(false);
    sortedFields: any;
    allInputFields: any;
    profileForm: FormGroup;
    isVideoLoad: boolean = true;
    videoSrc: any;
    isApiCall: boolean = false;
    isProspectUploded = new BehaviorSubject<Boolean>(false);
    campaignName: any = '';
    isOpenSendTestModel = new BehaviorSubject<Boolean>(false);
    isOpenTempModel = new BehaviorSubject<Boolean>(false);
    isDownloadCsv: boolean = false;
    activeTabIndex: number = 0;
    activeStatusIndex:  number = 0;
    activeArchivedTabIndex: number = 0;
    isSequencesCompleted: boolean = true;
    
    // spintax
    isOpenSpintaxDialog = new BehaviorSubject<boolean>(false);
    defaultInputs: any[] = [
        {
            label: 'CAMPAIGN.VARIANT',
            hint_text: 'CAMPAIGN.THANK_YOU_FOR_REACHING_OUT_TO_US',
            value: '',
        },
        {
            label: 'CAMPAIGN.VARIANT',
            hint_text: 'CAMPAIGN.WE_APPRECIATE_YOU_CONTACTING_US',
            value: '',
        },
        {
            label: 'CAMPAIGN.VARIANT',
            hint_text: 'CAMPAIGN.THANKS_FOR_GETTING_IN_TOUCH_WITH_US',
            value: '',
        },
    ];
    inputs: any[] = this.util.deepCopy(this.defaultInputs);
    constructor(
        private api: ApiService,
        private util: UtilService,
        private translater: TranslateService,
        private dialog: MatDialog,
        private location: LocationStrategy,
        private onboardingService: OnboardingService,
        private _router: Router
    ) {
        this.translater.get('ERROR_MESSAGE').subscribe({
            next: (lres: any) => {
                this.errorMessageData = lres;
            },
        });

        this._router.events.subscribe((event: any) => {
            if (event.routerEvent instanceof NavigationEnd) {
                console.log('event.routerEvent.url', event.routerEvent.url);
            }
        });
    }

    uploadFile(e) {
        console.log('evnet upload file', e);
        let fileSizeMb: any = (e.target.files[0].size / (1024 * 1024)).toFixed(
            2
        );
        if (fileSizeMb < 10) {
            const fileName = e.target.files[0].name.split('.');
            if (
                fileName &&
                fileName[fileName.length - 1].toLowerCase() != 'csv'
            ) {
                this.util.showToast(
                    this.errorMessageData['CHOOSE_CSV_FILE'],
                    true
                );
            } else {
                this.attachFiles = e.target.files[0];
                console.log('attachFiles', this.attachFiles);
                this.uploadBluckProspect();
            }
        } else {
            this.util.showToast(
                this.errorMessageData['ATTACHMENT_SIZE_ERROR'],
                true
            );
        }

        // Clear the file input value
        e.target.value = null;
    }

    handleFile(e) {
        console.log(e);
        if (e.addedFiles.length > 0) {
            let uploadFile = e.addedFiles[0];
            let fileSizeMb: any = (uploadFile.size / (1024 * 1024)).toFixed(2);
            if (fileSizeMb < 10) {
                const fileName = uploadFile.name.split('.');
                if (
                    fileName &&
                    fileName[fileName.length - 1].toLowerCase() != 'csv'
                ) {
                    console.log('fileName', fileName);
                    this.util.showToast(
                        this.errorMessageData['CHOOSE_CSV_FILE'],
                        true
                    );
                } else {
                    this.attachFiles = e.addedFiles[0];
                    console.log('attachFiles', this.attachFiles);
                    this.uploadBluckProspect();
                }
            } else {
                this.util.showToast(
                    this.errorMessageData['ATTACHMENT_SIZE_ERROR'],
                    true
                );
            }
        }
    }

    uploadBluckProspect() {
        this.mappingData = '';
        console.log('fileUpload', this.fileUpload);
        setTimeout(() => {
            this.openImpotCsvModel();
        });
        if (this.isUploadProspect) return;
        this.isUploadProspect = true;
        const fd = new FormData();
        fd.append('file', this.attachFiles);
        fd.append('type', this.type);
        fd.append('type_id', this.activeListId);
        this.api.postData('prospect-bulk-upload', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.util.showToast(res.message);
                    this.onboardingService.errMsg = '';
                    this.mappingData = res.data;
                    this.isLoadMapping.next(true);
                    console.log('mappingData', this.mappingData);
                    let doNotImport: any = this.mappingField.filter((f) => {
                        return f.column_key == 'do_not_import';
                    });

                    this.mappingData.columns.forEach((column) => {
                        column.selectedValue = '';
                        for (const mapKey in this.mappingData) {
                            if (this.mappingData[mapKey] == column.key) {
                                column.selectedValue = mapKey;
                            }
                        }
                        if (column.selectedValue == '') {
                            column.selectedValue = doNotImport[0]?.column_key;
                            console.log(
                                'column.selectedValue',
                                column.selectedValue
                            );
                        }
                    });
                } else {
                    this.util.showToast(res.message, true);
                    this.dialog.closeAll();
                    this.onboardingService.errMsg = res.message;
                }

                this.isUploadProspect = false;
            },

            error: (err) => {
                console.log('err', err);
                this.isUploadProspect = false;
            },
        });
    }

    openImpotCsvModel(model?) {
        const dialogRef = this.dialog.open(ImportCsvComponent, {
            autoFocus: false,
            minWidth: '770px',
            maxWidth: '800px',
            panelClass: 'custom_modal',
        });

        dialogRef.afterClosed().subscribe({
            next: (res: any) => {},
        });
    }

    getMappingtProgress(type?) {
        console.log('type', type);
        console.log('progressbarLoad', this.progressbarLoad);
        console.log('api call');
        var reqCount = 1;
        let interval;
        var makeApiCall = () => {
            if (!this.isApiCall) {
                this.isApiCall = true;
                if (
                    this.progressbarLoad?.progress < 100 &&
                    this.progressbarLoad?.cancelledAt != null
                ) {
                    this.util.showToast('Verification is canceled', true);
                    console.log('check progress canceled');
                    clearInterval(interval);
                    this.isLodingMapping = false;
                    this.isApiCall = false;
                    return;
                }
                if (
                    (this.progressbarLoad &&
                        this.progressbarLoad?.progress >= 100) ||
                    this.progressbarLoad?.cancelledAt != null ||
                    this.progressbarLoad?.finishedAt != null
                ) {
                    console.log('check progress match');
                    clearInterval(interval);
                    this.isLodingMapping = false;
                    this.isApiCall = false;
                    return;
                }

                const startTime = new Date(this.progressbarLoad?.createdAt);
                const stopTime = new Date(startTime.getTime() + 30 * 60 * 1000);
                const currentTime = new Date();

                if (currentTime >= stopTime) {
                    console.log('return api call');
                    clearInterval(interval);
                    this.isLodingMapping = false;
                    this.isApiCall = false;
                    return;
                }
                

                this.currentUrl = this.location.path();
                const url = '/prospect-management';
                const prospectingPaths = [
                    '/campaign/all/create-campaign/prospecting',
                    '/campaign-builder/create-campaign/prospecting',
                    '/campaign-builder/manage-campaign/prospecting'
                  ];
                if (
                    (type == 'prospecting' && !prospectingPaths.some(path => this.currentUrl.includes(path))) ||
                    (type == 'prospects' &&
                        !this.currentUrl.includes('/prospect-management')) ||
                    (type == 'onboardingProspects' &&
                        !this.currentUrl.includes('/onboarding')) || (type == 'prospects-finder' && !this.currentUrl.includes('/prospect-finder'))
                ) {
                    clearInterval(interval);
                    this.isLodingMapping = false;
                    this.isApiCall = false;
                    return;
                }
                this.api
                    .getData('get-prospect-progress/' + this.progressbarLoad.id)
                    .subscribe({
                        next: (res: any) => {
                            if (res.success) {
                                this.isProgressLoad.next(true);
                                this.progressbarLoad = res.data;
                                this.isLoadProgress.next(true);
                                if (reqCount == 8) {
                                    clearInterval(interval);
                                    setTimeout(() => {
                                        this.getMappingtProgress(type);
                                    }, 15000);
                                }
                                reqCount++;
                                if (this.progressbarLoad.progress == 100) {
                                    console.log(
                                        'emailVerificationProgress',
                                        this.progressbarLoad,
                                        this.progressbarLoad.progress
                                    );
                                    this.util.showToast(
                                        'Prospect imported successfully'
                                    );
                                    if (this.currentUrl == url) {
                                        this.isLoadAllCustomers.next(true);
                                    }
                                    if (
                                        prospectingPaths.some(path => this.currentUrl.includes(path))
                                    ) {
                                        this.isLoadingProspect.next(true);
                                    }
                                    if (
                                        !window.location.href.includes(
                                            '/onboarding'
                                        )
                                    ) {
                                        this.dialog.closeAll();
                                    }
                                    if (
                                        window.location.href.includes(
                                            '/onboarding'
                                        )
                                    ) {
                                        this.isProspectUploded.next(true);
                                    }
                                    clearInterval(interval);
                                    this.isLodingMapping = false;
                                }
                                console.log('get interval', interval);
                            } else {
                                this.util.showToast(res.message, true);
                            }
                            this.isApiCall = false;
                            console.log(
                                'isLodingMapping ',
                                this.isLodingMapping
                            );
                        },
                        error: (err) => {
                            console.log('err', err);
                            this.isApiCall = false;
                        },
                    });
            }
        };
        this.isProgressLoad
            .pipe(debounceTime(5000), distinctUntilChanged())
            .subscribe((modal) => {
                console.log('modal', modal);
                if (modal == true) {
                    interval = setInterval(makeApiCall, 5000);
                }
            });
        makeApiCall();
    }

    getCustomField() {
        this.api.getData('get-custom-field').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.customFields = res;
                    this.isCustomFieldLoad.next(true);
                    console.log('customFields', this.customFields);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
            },
            complete() {},
        });
    }

    downloadAnalyticsCsv(id?, status?) {
        console.log('check before condition', status)
        if(status && status.toLowerCase() == 'draft') {
            this.util.showToast('No analytics data available', true);
            return;
        }
        console.log('check after condition');
        if(this.isDownloadCsv) return;
        this.isDownloadCsv = true;
        this.api.getData(`export-analytics/${id}`).subscribe({
            next: (res:any) => {
                if (res.success) {
                    window.open(res.data, '_blank');
                } else {
                    this.util.showToast(res.message, true);
                }
                this.isDownloadCsv = false;
            },

            error: (err) => {
                console.log('err', err);
                this.isDownloadCsv = false;
            },
            complete() {
                this.isDownloadCsv = false;
            },
            
        })
    }
}
